import axios from "axios";

const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:3000/api";

const apiClient = axios.create({ baseURL: `${API_BASE}/assets` });

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

const assetService = {
  getMyAssets: (params = {}) =>
    apiClient.get("/my", { params }).then((res) => res.data),

  getAssetSummary: (params = {}) =>
    apiClient.get("/summary", { params }).then((res) => res.data),

  getAssetById: (id) => apiClient.get(`/${id}`).then((res) => res.data),

  raiseAssetQuery: ({ assetId, message }) =>
    apiClient.post(`/${assetId}/query`, { message }).then((res) => res.data),
};

export default assetService;
